import styled from "styled-components";
import Modal from "@iso/components/Feedback/Modal";
import WithDirection from "@iso/lib/helpers/rtl";

const SignatureComponentWrapper = styled(Modal)`
  
`;

export default WithDirection(SignatureComponentWrapper);
